module.exports = __webpack_public_path__ + "img/cooperation-case.c5f0c35e.png";